import { supabase } from '../lib/supabase';

export class AdminKeyService {
  private static readonly LOCAL_SECRET_KEY = 'admin_secret_fallback';

  static setLocalSecret(secret: string) {
    try {
      const v = String(secret || '').trim();
      if (!v) {
        window.localStorage.removeItem(AdminKeyService.LOCAL_SECRET_KEY);
        return;
      }
      window.localStorage.setItem(AdminKeyService.LOCAL_SECRET_KEY, v);
    } catch {
    }
  }

  static clearLocalSecret() {
    try {
      window.localStorage.removeItem(AdminKeyService.LOCAL_SECRET_KEY);
    } catch {
    }
  }

  static getLocalSecret(): string | null {
    try {
      const v = window.localStorage.getItem(AdminKeyService.LOCAL_SECRET_KEY);
      const s = String(v || '').trim();
      return s ? s : null;
    } catch {
      return null;
    }
  }

  static async getSecret(): Promise<string | null> {
    try {
      const { data, error } = await supabase
        .from('admin_key')
        .select('secret')
        .eq('id', 1)
        .maybeSingle();

      if (error) {
        console.error('Error fetching admin key:', error);
        return AdminKeyService.getLocalSecret();
      }

      return data?.secret || AdminKeyService.getLocalSecret();
    } catch (e) {
      console.error('Unexpected error fetching admin key:', e);
      return AdminKeyService.getLocalSecret();
    }
  }

  static async getSignupSecret(): Promise<string | null> {
    try {
      const { data, error } = await supabase
        .from('admin_signup_key')
        .select('secret')
        .eq('id', 1)
        .maybeSingle();

      if (error) {
        console.error('Error fetching admin signup key:', error);
        return null;
      }

      return data?.secret || null;
    } catch (e) {
      console.error('Unexpected error fetching admin signup key:', e);
      return null;
    }
  }

  static async verifySignupSecret(candidate: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.rpc('verify_admin_signup_key', { candidate });
      if (error) {
        console.error('Error verifying admin signup key:', error);
        return false;
      }
      return Boolean(data);
    } catch (e) {
      console.error('Unexpected error verifying admin signup key:', e);
      return false;
    }
  }

  static async verifyAnyKey(candidate: string): Promise<boolean> {
    try {
      const { data, error } = await supabase.rpc('verify_admin_any_key', { candidate });
      if (error) {
        console.error('Error verifying admin key (any):', error);
        try {
          const res = await fetch('/api/admin-fallback.php', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ action: 'admin_fallback_verify_secret', candidate }),
          });
          const json = await res.json().catch(() => null);
          return Boolean(json?.ok && json?.valid);
        } catch {
          return false;
        }
      }
      return Boolean(data);
    } catch (e) {
      console.error('Unexpected error verifying admin key (any):', e);
      try {
        const res = await fetch('/api/admin-fallback.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'admin_fallback_verify_secret', candidate }),
        });
        const json = await res.json().catch(() => null);
        return Boolean(json?.ok && json?.valid);
      } catch {
        return false;
      }
    }
  }
}

